export default __webpack_public_path__ + "static/media/office2-afterA-480w.83d9e0e8.png";